import styled, { css } from 'styled-components/macro'
import { fluidSystem, theme, ChartWrapper } from 'styled'

import { Root, OptionsRow, DonutButton } from './../DonutQuestion/DonutQuestion.styled'

export { Root, OptionsRow, DonutButton }

export const Pie = styled(ChartWrapper)`
  ${fluidSystem};
  /* flex: 0 999 auto;
  height: 100%;
  width: 100%; */
  display: flex;
  justify-content: center;
  align-items: center;

  > .Inner {
    /* width: 100%;
    height: 100%; */
    max-height: 450px;
  }

  svg {
    width: 100%;
    height: 100%;
    overflow: visible;
  }
`

const pathModes = {
  outline: css`
    fill: ${({ highlight }) => theme.colors[highlight ? 'secondary' : 'white']};
    stroke: ${theme.colors.mediumGrey};
  `,
  selection: css`
    fill: ${theme.colors.primary};
    opacity: ${({ selected, highlight }) => (selected && !highlight ? 1 : 0)};
  `,
}

export const SlicePath = styled.path.attrs({
  vectorEffect: 'non-scaling-stroke',
})`
  ${({ mode }) => pathModes[mode]};
  stroke-width: 1px;
  transition: all 0.2s;
`
